import { useMutation, useQueryClient } from "react-query";
import {
  ProjectAddDto,
  ProjectListDto,
  useProjectApi,
} from "~/api/GeneratedApi";
import { useApiErrorHandler } from "~/utils/hooks/useApiErrorHandler";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";

export const useProjects = () => {
  const { getProjects } = useProjectApi();

  const { data } = useCustomQuery(
    "projects",
    async () => {
      const d = await getProjects();
      return d.results;
    },
    { staleTime: Infinity },
  );

  return { data };
};

export type PTOPProjectCreateDto = Omit<ProjectListDto, "id">;

export const useAddProjects = () => {
  const qc = useQueryClient();

  const { addProject: add } = useProjectApi();

  const { mutate: addProject } = useMutation({
    mutationFn: (d: ProjectAddDto) => add(d),
    onSuccess: () => {
      void qc.invalidateQueries("projects");
    },
  });

  return { addProject };
};

export const useRemoveProject = () => {
  const qc = useQueryClient();
  const handleApiError = useApiErrorHandler();
  const { removeProject: remove } = useProjectApi();

  const { mutate: removeProject } = useMutation({
    mutationFn: (id: number) => remove(id),
    onSuccess: () => {
      void qc.invalidateQueries("projects");
    },
    onError: handleApiError,
  });

  return { removeProject };
};
